const navFreeze = (() => {
  const config = {
    checkbox: document.getElementById('menu-trigger'),
    mobileNav: document.getElementsByClassName('nav__mobile')[0],
    freezeCN: 'freeze',
  };

  const hideNav = () => {
    config.checkbox.checked = false;
    document.body.classList.remove(config.freezeCN);
  };

  const showNav = () => {
    document.body.classList.add(config.freezeCN);
  };

  const handleClick = ({ e }) => {
    if (
      document.body.classList.contains(config.freezeCN) &&
      !config.mobileNav.contains(e.target)
    ) {
      hideNav();
    }
  };

  const handleChange = () => {
    try {
      if (config.checkbox.checked) {
        showNav();
      } else {
        hideNav();
      }
    } catch (e) {
      console.log(e);
    }
  };

  const init = () => {
    // Close mobile nav if click on outside area
    document.addEventListener('click', e => handleClick({ e }));

    config.checkbox.addEventListener('change', () => handleChange());
    config.checkbox.dispatchEvent(new Event('change'));
  };

  return {
    init,
  };
})();

navFreeze.init();
